import Common from '../../Common';

interface CreateBody {
	license_id: id,
}

const License = class extends Common {
	browse = (companyId: id): CustomResponseWithPagination<{ licenses: License[] }> =>
		this.get(`/company/${companyId}/license`)

	create = (companyId: id, body: CreateBody) =>
		this.post(`/company/${companyId}/license`, body)

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/license/${id}`)
}

export default License;
